import axios from 'axios';

export const fileService = {
  rename(id, type, newFileName) {
    return axios.post('/api/documents/rename/', {
      IsFolder: false,
      ObjectID: id,
      ObjectType: type,
      NewName: newFileName
    });
  },
  openFileBrowser: async (options = {}) => {

    const fallbackFilePicker = (options = {}) => {
      return new Promise((resolve) => {
        const input = document.createElement('input');
        input.type = 'file';
        
        // set options
        if (options.multiple) input.multiple = true;
        
        // handle accept option - convert types to accept format
        if (options.types && options.types.length > 0) {
          // convert types array to accept string
          const acceptTypes = options.types.flatMap(type => 
            type.accept ? Object.values(type.accept).flat() : []
          );
          
          if (acceptTypes.length > 0) {
            input.accept = acceptTypes.join(',');
          }
        }
        
        // handle file selection
        input.onchange = (event) => {
          if (!event.target.files || event.target.files.length === 0) {
            resolve(null);
            return;
          }
          
          // for multiple files, return array, otherwise single file
          const result = options.multiple ? 
            Array.from(event.target.files) : 
            event.target.files[0];
          
          // clean up
          document.body.removeChild(input);
          
          resolve({
            // mimic FileSystemFileHandle API for compatibility
            getFile: async () => result,
            file: result,
            kind: 'file',
            name: options.multiple ? undefined : result.name
          });
        };
        
        // handle cancellation
        window.addEventListener('focus', function onFocus() {
          setTimeout(() => {
            // if no files were selected after dialog closes
            if (input.files.length === 0) {
              document.body.removeChild(input);
              window.removeEventListener('focus', onFocus);
              resolve(null);
            }
          }, 300);
        }, { once: true });
        
        // add to DOM and trigger click
        input.style.display = 'none';
        document.body.appendChild(input);
        input.click();
      });
    }


    // check if File System Access API is supported
    if ('showOpenFilePicker' in window) {
      try {
        const pickerOptions = {
          types: options.types || [],
          excludeAcceptAllOption: options.excludeAcceptAllOption || false,
          multiple: options.multiple || false
        };
        
        if (options.multiple) {
          
          let fileHandles = await window.showOpenFilePicker(pickerOptions);
          const fileList = await Promise.all(fileHandles.map(fh => fh.getFile()));

          return { file: fileList, getFile: () => fileList, kind: 'file' };
        } else {
          const [fileHandle] = await window.showOpenFilePicker(pickerOptions);
          return fileHandle;
        }
      } catch (error) {
        // if user cancels, don't fall back
        if (error.name === 'AbortError') {
          return null;
        }
        
        // for other errors, fall back to the traditional method
        console.warn('File System Access API error, falling back:', error);
        return fallbackFilePicker(options);
      }
    } else {
      // fall back to traditional file input if API not supported
      console.info('File System Access API not supported, using fallback');
      return fallbackFilePicker(options);
    }
  }
};